export const passwordAllowedSymbolsRegExp = /^[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/
export const emailAllowedSymbolsRegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/
export const discordAllowedSymbolsRegExp = /^.{2,32}#[0-9]{4}$|^@?(?!.*\.{2})[a-zA-Z0-9._]{2,32}$/
export const telegramAllowedSymbolsRegExp = /^@[\w\d_]{5,32}$/
export const systemPromoCodes = ['Whitelist']

export const passwordSpecialCharacters = /^(?=.*[!"#$%&()*+,-./:;<=>?@[\]^_`{|}~\\'])/
